<template>
    <div class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '圖表'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g" :class="'leng_'+ charts.length" v-if="charts.length">
                    <mdChart v-for="(chart, index) in charts" :key="index" :obj="chart"></mdChart>
                </div>
                <div class="g" v-else>
                    <mdChart :obj="chart"></mdChart>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdChart from '@/components/mdChart'
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdChart,
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = '100vw';
            }

            return {
                styleSet: $styleSet,
                chart: {},
                charts: [],
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content;

                $content[func]();
            },
            action: function(){
                let $content = this.content,
                    $_action = $content.action;

                if( this.haveAction ) {
                    $_action();
                }

                if( $content.actionStopClose !== true ) {
                    this.close();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        },
        created: function(){
            let $content = this.content,
                $data = $content.data;

            if( $data ) {
                let _prop = 'chart';

                if( Array.isArray($data) ) {
                    _prop = 'charts';
                }
                
                this.$set(this, _prop, $data);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
